import React, { useState, useEffect, useRef } from "react";
import ScopeSummaryBox from "../../../../planning/dailyDispatch/workScopeSummary/ScopeSummaryBox";

/**
 * ScopeCardWrapper Component
 * Wraps a ScopeSummaryBox and tracks its own width for hover positioning
 */
const ScopeCardWrapper = ({
  scope,
  job,
  isSelected = false,
  onClick,
  readOnly = false,
}) => {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);

  // ResizeObserver to track individual card width
  useEffect(() => {
    if (!containerRef.current) return;

    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        setContainerWidth(entry.contentRect.width);
      }
    });

    resizeObserver.observe(containerRef.current);

    return () => {
      resizeObserver.disconnect();
    };
  }, []);

  return (
    <div
      ref={containerRef}
      className={`max-w-[380px] ${
        isSelected ? "ring-2 ring-blue-500 rounded" : ""
      } ${!readOnly ? "cursor-pointer" : ""}`}
      onClick={!readOnly ? onClick : undefined}
    >
      <ScopeSummaryBox
        scope={scope}
        job={job}
        containerWidth={containerWidth}
        display="report"
      />
    </div>
  );
};

export default ScopeCardWrapper;
